import { PropsWithChildren, useEffect } from 'react';
import { addToContext, getContext } from '../services/contextManager';
import { tracker, trackerNormalize } from '../services/trackerManager';
import { useLocation } from 'react-router';
import { useGetPageName } from '../services/flowManager';

export const TrackerWrapper = ({ children }: PropsWithChildren) => {
  const pageName = useGetPageName();

  const location = useLocation();
  useEffect(() => {
    const context = getContext();
    if (pageName) {
      addToContext('view', pageName);
      tracker.page(location.pathname, {
        ...trackerNormalize(context || {}),
        page_name: pageName,
      });
    }
  }, [pageName]);
  return <>{children}</>;
};
